// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Sq3","is-link":"_3PBV","red":"_1Ujn","blue":"_1GeY","green":"_2T3P","dark-blue":"_2njV","yellow":"_3C49","purple":"rAzI","pink":"TjRa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ButtonSupplimentaryText/styles.scss
// module id = 149
// module chunks = 0